import React, { useEffect } from 'react'
import { ArrowRight, ArrowUp, BookOpen, Check, ChevronLeft, ChevronRight, Circle, Facebook, GitHub, Instagram, Linkedin, Menu, Slack, Tv, Twitter, X } from 'react-feather'
import aos from 'aos'
import contact from '../assets/images/logo/khuram.png'


const Contact = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])
    return (
        <>
            {/* <!-- Start Contact section --> */}
            <div className="rn-contact-area rn-section-gap section-separator" id="contacts">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center">
                                <span className="subtitle">Contact</span>
                                <h2 className="title">Contact With Me</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt--50 mt_md--40 mt_sm--40 mt-contact-sm">
                        <div className="col-lg-5">
                            <div className="contact-about-area">
                                <div className="thumbnail">
                                    <img src={contact} alt="contact-img" />
                                </div>
                                <div className="title-area">
                                    <h4 className="title">Khuram Haseeb</h4>
                                    <span>Full Stack Web and Mobile Developer</span>
                                </div>
                                <div className="description">
                                    <p>I am available for freelancing work. Connect with me via and call in to my account.
                                    </p>
                                    <span className="phone">Phone: <a href="tel:+923057857446">+923057857446</a></span>
                                    <span className="mail">Email: <a href="mailto:khuramhaseeb1150@gmail.com">khuramhaseeb1150@gmail.com</a></span>
                                </div>
                                <div className="social-area">
                                    <div className="name">FIND WITH ME</div>
                                    <div className="social-icone">
                                        <ul className="social-share d-flex liststyle">
                                            <li className="facebook"><a href="https://app.slack.com/client/T02J391F0UE/D033DA58GP6/user_profile/U02JNJWTHC1" target="_blank"><Slack /></a>
                                            </li>
                                            <li className="linkedln"><a href="skype:live:khuramhaseeb1150" target="_blank"><i style={{ color: 'black', marginTop: '15px' }} className="fa-brands fa-skype fa-2x"></i></a>
                                            </li>
                                            <li className="instagram"><a href="https://github.com/Khuram-Haseeb1150" target="_blank"><GitHub />
                                            </a>
                                            </li>
                                            <li className="instagram"><a href="https://www.linkedin.com/in/khuram-haseeb/" target="_blank"><Linkedin />
                                            </a>
                                            </li>
                                            <li className="instagram"><a href="https://web.facebook.com/ranakhuram.prince.7" target="_blank"><Facebook />
                                            </a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-aos-delay="600" className="col-lg-7 contact-input">
                            <div className="contact-form-wrapper">
                                <div className="introduce">
                                    <form className="rnt-contact-form rwt-dynamic-form row" id="contact-form" method="POST" action="mail.php">

                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label for="contact-name">Your Name</label>
                                                <input className="form-control form-control-lg" name="contact-name" id="contact-name" type="text" />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label for="contact-phone">Phone Number</label>
                                                <input className="form-control" name="contact-phone" id="contact-phone" type="text" />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label for="contact-email">Email</label>
                                                <input className="form-control form-control-sm" id="contact-email" name="contact-email" type="email" />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label for="subject">subject</label>
                                                <input className="form-control form-control-sm" id="subject" name="subject" type="text" />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label for="contact-message">Your Message</label>
                                                <textarea name="contact-message" id="contact-message" cols="30" rows="10"></textarea>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <button name="submit" type="submit" id="submit" className="rn-btn">
                                                <span>SEND MESSAGE</span>
                                                <ChevronRight />
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Contuct section --> */}

        </>
    )
}

export default Contact